import { render, staticRenderFns } from "./Telepathy.vue?vue&type=template&id=0430d334&lang=pug&"
import script from "./Telepathy.vue?vue&type=script&lang=ts&"
export * from "./Telepathy.vue?vue&type=script&lang=ts&"
import style0 from "./Telepathy.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports